<template>
  <el-submenu
    v-if="isDirectory"
    :index="menuIndex"
  >
    <template slot="title">
      <i :class="item.icon"></i>
      <span>{{ item.title }}</span>
    </template>

    <sidebar-menu-item
      v-for="child in children"
      :key="child.id || child.path || child.index"
      :item="child"
    />

    <el-menu-item
      v-if="!children.length"
      :index="`${menuIndex}__empty`"
      disabled
    >
      暂无子菜单
    </el-menu-item>
  </el-submenu>

  <el-menu-item v-else :index="menuIndex">
    <i :class="item.icon"></i>
    <span slot="title">{{ item.title }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'SidebarMenuItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    children() {
      return Array.isArray(this.item.children) ? this.item.children : []
    },
    isDirectory() {
      return this.item.type === 'directory' || this.children.length > 0
    },
    menuIndex() {
      return this.item.path || this.item.id || this.item.index || `menu_${this.item.title || 'unknown'}`
    }
  }
}
</script>
